import { LogRecord } from "./core";

export * from "./config";

export default LogRecord;
